import { render, staticRenderFns } from "./searchPosition.vue?vue&type=template&id=4af5da7f&scoped=true"
import script from "./searchPosition.vue?vue&type=script&lang=js"
export * from "./searchPosition.vue?vue&type=script&lang=js"
import style0 from "./searchPosition.vue?vue&type=style&index=0&id=4af5da7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5da7f",
  null
  
)

export default component.exports